<app-table [useFixedHeader]="true">
  <app-table-headers>
    <app-table-header>First name</app-table-header>
    <app-table-header>Last name</app-table-header>
    <app-table-header>Email</app-table-header>
    <app-table-header class="flex-double flex-center">Status</app-table-header>
  </app-table-headers>

  <ng-template #empty>
    <app-table-content-empty>
      <ng-container nodata>
        <p>No Trial Accounts requests</p>
      </ng-container>
    </app-table-content-empty>
  </ng-template>

  <app-loading-spinner *ngIf="isLoading; else content"></app-loading-spinner>

  <ng-template #content>
    <app-table-content *ngIf="trialAccountsRequests?.length; else empty">
      <app-table-row
        *ngFor="let request of trialAccountsRequests; trackBy: trackByTrialFn"
        [appScrollToRequest]="request.id === selectedRequestId"
        [ngClass]="{ selected: request.id === selectedRequestId }"
        appTrialRequestLeaveRow
        [pop1]="p1"
        [pop2]="p2"
        [pop3]="p3"
      >
        <app-table-cell>
          <div
            class="cell"
            [ngbPopover]="content"
            triggers="manual"
            [autoClose]="false"
            #p1="ngbPopover"
            appTrialRequestEnterCell
            [pop1]="p1"
            [pop2]="p2"
            [pop3]="p3"
          >
            {{ request.firstName }}
          </div>
        </app-table-cell>
        <app-table-cell
          ><div
            class="cell"
            [ngbPopover]="content"
            triggers="manual"
            [autoClose]="false"
            #p2="ngbPopover"
            appTrialRequestEnterCell
            [pop1]="p2"
            [pop2]="p1"
            [pop3]="p3"
          >
            {{ request.lastName }}
          </div></app-table-cell
        >
        <app-table-cell
          ><div
            class="cell"
            [ngbPopover]="content"
            triggers="manual"
            [autoClose]="false"
            #p3="ngbPopover"
            appTrialRequestEnterCell
            [pop1]="p3"
            [pop2]="p1"
            [pop3]="p2"
          >
            {{ request.email }}
          </div></app-table-cell
        >
        <app-table-cell class="flex-double">
          <ng-container [ngSwitch]="request.status">
            <ng-container
              *ngSwitchCase="TrialAccountRequestStatus.New"
              [ngTemplateOutlet]="buttons"
              [ngTemplateOutletContext]="{
                request: request,
                disabled: !hasTrialDispenserRole
              }"
            ></ng-container>
            <ng-container
              *ngSwitchCase="TrialAccountRequestStatus.Approved"
              [ngTemplateOutlet]="status"
              [ngTemplateOutletContext]="{
                name: 'Approved',
                class1: TrialAccountRequestStatus.Approved,
                class2: 'fa-check'
              }"
            ></ng-container>
            <ng-container
              *ngSwitchCase="TrialAccountRequestStatus.Declined"
              [ngTemplateOutlet]="statusDecline"
              [ngTemplateOutletContext]="{
                request: request,
                disabled: !hasTrialDispenserRole,
                name: 'Declined',
                class1: TrialAccountRequestStatus.Declined,
                class2: 'fa-trash'
              }"
            ></ng-container>
          </ng-container>
        </app-table-cell>
        <ng-template #content>
          <div class="request-content">
            <div>
              <span class="request-content--title">First name: </span
              >{{ request.firstName }}
            </div>
            <div>
              <span class="request-content--title">Last name: </span
              >{{ request.lastName }}
            </div>
            <div>
              <span class="request-content--title">Email: </span
              >{{ request.email }}
            </div>
            <div>
              <span class="request-content--title">Phone number: </span
              >{{ request.phoneNumber }}
            </div>
            <div>
              <span class="request-content--title">company: </span
              >{{ request.companyName }}
            </div>
            <div>
              <span class="request-content--title">Job title: </span
              >{{ request.jobTitle }}
            </div>
            <div>
              <span class="request-content--title">IP address: </span
              >{{ request?.metadata?.ipAddress }}
            </div>
            <div>
              <span class="request-content--title">Requested at: </span>
              {{ request.requestedAt | date }}
            </div>
            <ng-container *ngIf="request.approvedAt">
              <div class="request-content__item">
                <span class="request-content--title">Account ID: </span>
                <a routerLink="/au/accounts/{{ request.accountId }}">
                  <strong>{{ request.accountId }}</strong>
                </a>
              </div>
              <div>
                <span class="request-content--title">Approved at: </span
                >{{ request.approvedAt | date }}
              </div>
            </ng-container>
            <ng-container *ngIf="request.declinedAt">
              <div>
                <span class="request-content--title">Declined at: </span
                >{{ request.declinedAt | date }}
              </div>
            </ng-container>
            <div class="request-content__item">
              <span class="request-content--title">Status: </span
              ><span class="status-item" [ngClass]="request.status">{{
                request.status
              }}</span>
            </div>
            <div>
              <span class="request-content--title">Id: </span>
              {{ request.id }}
            </div>
          </div>
        </ng-template>
      </app-table-row>
    </app-table-content>
  </ng-template>
</app-table>

<ng-template #status let-name="name" let-class1="class1" let-class2="class2">
  <div class="status">
    <div class="status-item" [ngClass]="class1">
      <i class="fas" [ngClass]="class2"></i>{{ name }}
    </div>
  </div>
</ng-template>

<ng-template
  #statusDecline
  let-request="request"
  let-disabled="disabled"
  let-name="name"
  let-class1="class1"
  let-class2="class2"
>
  <div class="status">
    <button
      *ngIf="!disabled; else disabledApprove"
      class="button btn btn-success"
      [ngbPopover]="approveConfirmation"
      triggers="manual"
      #p1="ngbPopover"
      [autoClose]="false"
      (click)="toggleApproveConfirmationPopup(p1, request)"
    >
      <i class="fas fa-check"></i>
      Approve
    </button>
    <div class="status-item" [ngClass]="class1">
      <i class="fas" [ngClass]="class2"></i>{{ name }}
    </div>
  </div>
</ng-template>

<ng-template #buttons let-request="request" let-disabled="disabled">
  <div class="status">
    <ng-container *ngIf="!disabled; else disabledButtons">
      <button
        class="button btn btn-success"
        [ngbPopover]="approveConfirmation"
        triggers="manual"
        #p1="ngbPopover"
        [autoClose]="false"
        (click)="toggleApproveConfirmationPopup(p1, request)"
      >
        <i class="fas fa-check"></i>
        Approve
      </button>
      <button
        class="button btn btn-danger"
        [ngbPopover]="declineConfirmation"
        triggers="manual"
        #p2="ngbPopover"
        [autoClose]="false"
        (click)="p1.close(); toggleDeclineConfirmationPopup(p2, request)"
      >
        <i class="fas fa-trash"></i>
        Decline
      </button>
    </ng-container>
    <ng-template #disabledButtons>
      <div class="status">
        <ng-container [ngTemplateOutlet]="disabledApprove"></ng-container>
        <ng-container [ngTemplateOutlet]="disabledDecline"></ng-container>
      </div>
    </ng-template>
  </div>
</ng-template>

<ng-template #approveConfirmation let-popover="popover" let-request="request">
  <div class="confirmation">
    <span>Are you sure you want to confirm the request</span>
    <div class="confirmation__buttons">
      <button
        class="button btn btn-outline-dark"
        (click)="popover.close(); approve.emit(request)"
      >
        Ok
      </button>
      <button class="button btn btn-danger" (click)="popover.close()">
        Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #declineConfirmation let-popover="popover" let-request="request">
  <div class="confirmation">
    <span>Are you sure you want to decline the request</span>
    <div class="confirmation__buttons">
      <button
        class="button btn btn-outline-dark"
        (click)="popover.close(); decline.emit(request)"
      >
        Ok
      </button>
      <button class="button btn btn-danger" (click)="popover.close()">
        Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #disabledApprove>
  <button
    ngbPopover="You do not have permission to approve the request"
    triggers="mouseenter:mouseleave"
    class="button btn btn-success"
    [disabled]="'true'"
  >
    <i class="fas fa-check"></i>
    Approve
  </button>
</ng-template>

<ng-template #disabledDecline>
  <button
    ngbPopover="You do not have permission to decline the request"
    triggers="mouseenter:mouseleave"
    class="button btn btn-danger"
    [disabled]="'true'"
  >
    <i class="fas fa-trash"></i>
    Decline
  </button>
</ng-template>
